<template>
  <base-section
    id="key-dates"
  >
    <base-section-heading
      title="Key Dates"
    />

    <v-container>
      <base-section-heading
      divider=null
      >
      <!---
      <v-col
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
      >
      --->
      <v-data-table
        :headers="headers"
        :items="dates"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:[`item.name`]="{ item }">
          <a
          v-if="item.to"
          @click="changeTab(item.to)"
          >
            {{ item.name }}
          </a>
          <div
          v-else
          >
            {{ item.name }}
          </div>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <span
          v-html="item.date"
          >
          </span>
        </template>
      </v-data-table>
      </base-section-heading>
      <!---</v-col>--->
      <br>
      <base-section-heading
        divider="null"
      >
        The IEEE European Test Symposium (ETS) 2023 seeks original, unpublished contributions of the following types:<br>
        • <strong>Late Industrial Contributions</strong>, for inclusion in the Informal Digest of Papers<br>
      </base-section-heading>
      <base-section-heading>
        We welcome you all to the 28th European Test Symposium ETS 2023 in Venice. The technical program of ETS 2023 addresses many trends and challenges in semiconductor design and manufacturing process covering a range of topics spanning from Analog, Mixed-Signal, RF, DfT, Test Access Standards, Validation, Verification Debug and Diagnosis, Test generation, Fault Simulation, Fault Tolerance, Application, and evaluation. Moreover, we added hot-topics that are now driving semiconductor business: Dependable AI, AI for Testing, Functional Safety and Reliability in Automotive Emerging technologies, Emerging architectures, Security, and Trust. Looking forward to your submissions.
      </base-section-heading>
       <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in submissionsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < submissionsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    name: 'KeyDates',

    data: () => ({
      isMobile: false,
      submissionsfooter: [
        {
          name: 'Submissions',
          url: 'submissions',
        },
        {
          name: 'Key Dates',
          url: 'key-dates',
        },
        {
          name: 'Topics',
          url: 'topics',
        },
        {
          name: 'Submit a Paper',
          url: 'cfp',
        },
        {
          name: 'Submission Guidelines',
          url: 'submission-guidelines',
        },
      ],
      headers: [
        {
          text: 'Deadline Date',
          value: 'date',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Type',
          value: 'name',
          sortable: false,
          align: 'left',
        },
      ],
      dates: [
        {
          name: 'Papers Abstract submission',
          date: '<s>9 December 2022</s> <strong>16 December 2022</strong> (<span style="color: red;"><strong>Final Deadline</strong></span>)',
        },
        {
          name: 'Papers Final PDF submission',
          date: '<s>16 December 2022</s> <strong>23 December 2022</strong> (<span style="color: red;"><strong>Final Deadline</strong></span>)',
        },
        {
          name: 'Workshops Proposal',
          date: '16 December 2022',
          to: 'workshops',
        },
        {
          name: 'Workshops Notification',
          date: '21 December 2022',
          to: 'workshops',
        },
        {
          name: 'PhD Forum submissions',
          date: '<s>15 January 2023</s> <strong>30 January 2023</strong> (<span style="color: red;"><strong>Extended Deadline</strong></span>)',
        },
        {
          name: 'McCluskey submissions',
          date: '<s>15 January 2023</s> <strong>30 January 2023</strong> (<span style="color: red;"><strong>Extended Deadline</strong></span>)',
        },
        {
          name: 'Papers Notification',
          date: '<s>6 February 2023</s> <strong>10 February 2023</strong> (<span style="color: red;"><strong>Extended Deadline</strong></span>)',
        },
        {
          name: 'Scientific and Industrial Papers Camera-ready',
          date: '10 March 2023',
        },
        {
          name: 'Special Track Papers Camera-ready',
          date: '31 March 2023',
        },
        {
          name: 'Authors Registration',
          date: '<s>22 February 2023</s> <strong>10 March 2023 <span style="color: red;">(Extended Deadline)</span></strong>',
        },
        {
          name: 'Late Industrial Contribution',
          date: '3 April 2023',
          to: 'cfp',
        },
        {
          name: 'Late Industrial Notification',
          date: '15 April 2023',
          to: 'cfp',
        },
        {
          name: 'Early-rate Registration',
          date: '21 April 2023',
        },
      ],
    }),
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      changeTab (to) {
        if (this.isMobileDevice()) {
          if (to === 'workshops') {
            to = 'fringe-workshops'
          }
          window.location.href = 'https://cas.polito.it/ETS23/#/' + to
        } else {
          document.getElementById(to).click()
        }
      },
    },
  }
</script>
